import {z} from 'zod';

const AvailableTemplateSchema = z.object({
  id: z.string(),
  title: z.string(),
  authorizationProfileId: z.string().nullable(),
  isHidden: z.boolean(),
});
export type AvailableTemplate = z.infer<typeof AvailableTemplateSchema>;

const AvailableDocumentSchema = z.object({
  documentCode: z.string().nullable(),
  title: z.string(),
  templates: z.array(AvailableTemplateSchema),
});
export type AvailableDocument = z.infer<typeof AvailableDocumentSchema>;

export const GetAvailableTemplatesResponseSchema = z.array(AvailableDocumentSchema);
export type GetAvailableTemplatesResponse = z.infer<typeof GetAvailableTemplatesResponseSchema>;

export const GetAvailableTemplatesRequestSchema = z.object({
  warehouseId: z.string().optional(),
  directSaleVariantId: z.string().optional(),
  supplierOrderVariantId: z.string().optional(),
});
export type GetAvailableTemplatesRequest = z.infer<typeof GetAvailableTemplatesRequestSchema>;
